/** @format */

import { Component, input } from '@angular/core';
import {
	homefieldIconChevronRight,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconToolStraighten
} from '@dsg-tech/homefield-angular-icons';
import { HmfAccordionComponent } from '@dsg-tech/homefield-angular';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';

@Component({
	imports: [HmfAccordionComponent, HomefieldIconLibraryModule, HtmlSanitizerPipe],
	standalone: true,
	selector: 'pdp-tech-specs',
	templateUrl: './tech-specs.component.html',
	styleUrls: ['./tech-specs.component.scss']
})
export class TechSpecsComponent {
	techSpecs = input<string>();
	isAccordionContentEnabled = input(false);
	isOOSProductSpecs = input(false);

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronRight,
			homefieldIconToolStraighten
		]);
	}
}
